










import { Component, Prop, Vue } from "vue-property-decorator";
import { Board, Tile as ITile } from "@/types";
import Tile from "./Tile.vue";

@Component({
  components: {
    Tile
  }
})
export default class BoardComponent extends Vue {
  @Prop() private board!: Board;
}
